import "./banner.css";
import React, { useEffect, useState } from "react";

const Banner = (props) => {
	const { message, banner } = props;
	const [showBanner, setShowBanner] = useState(banner);
	const [bannerMessage, setBannerMessage] = useState(message);
	const [additionalClassName, setAdditionalClassName] = useState("");

	useEffect(() => {
		if (message !== "") {
			setBannerMessage(message);
			if (banner === true) {
				setShowBanner(true);
				setTimeout(() => {
					closeBanner();
				}, 5000);
			}
		} else {
			setShowBanner(false);
		}
	}, [banner, message]);

	const closeBanner = () => {
		setAdditionalClassName("closing");
		setTimeout(() => {
			setAdditionalClassName(""); // Remove "closing" class after the timeout
			setShowBanner(false); // Hide the banner
		}, 2000);
	};
	return (
		<>
			{showBanner && (
				<div className={`banner ${additionalClassName}`}>
					<span className="banner-text">
						{bannerMessage}
						<span
							onClick={closeBanner}
							class="material-symbols-outlined close-button">
							close
						</span>
					</span>
				</div>
			)}
		</>
	);
};
export default Banner;
